import { Controller, useForm, SubmitHandler } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import CloseIcon from '@mui/icons-material/Close';
import {
  Drawer,
  Typography,
  IconButton,
  TextField,
  MenuItem,
  Button,
  Box,
  FormControl,
  Autocomplete,
} from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { useGetCitiesQuery } from 'features/getCities/api/getCitiesApi';
import { useCreateParticipantMutation } from 'features/createParticipant/createParticipant';
import React from 'react';

type FormDataType = {
  title: string;
  status: number;
  direction: number;
  tier: number;
  id_1c: string;
  door_code: string;
  city_id: number;
  address: string;
};

const tierList = [
  {
    value: 'TOP',
    id: 0,
  },
  {
    value: 'MIDDLE',
    id: 1,
  },
  {
    value: 'LOW',
    id: 2,
  },
];
const statusList = [
  {
    value: 'ACTIVE',
    id: 0,
  },
  {
    value: 'BLOCKED',
    id: 1,
  },
];

const directionList = [
  {
    value: 'KAM',
    id: 0,
  },
  {
    value: 'DS',
    id: 1,
  },
  {
    value: 'OP',
    id: 2,
  },
];
export const DrawerShopDots = () => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen, actionDrawer } = useAppSelector((state) => state.ui);
  const { data: cities, isSuccess: citiesListSuccess } = useGetCitiesQuery({ sort: 'country_id,name_ru' });
  const [createNewsRequest] = useCreateParticipantMutation();

  const onSubmit: SubmitHandler<FormDataType> = () => {
    const data = getValues();
    createNewsRequest({
      title: data.title,
      status: data.status,
      direction: data.direction,
      tier: data.tier,
      id_1c: data.tier,
      door_code: data.door_code,
      city_id: data.city_id,
      address: data.address,
    }).then(() => {
      dispatch(setDrawerOpen(false));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  };

  const {
    control,
    handleSubmit,
    watch,
    getValues,
    formState: { errors: formErrors },
  } = useForm<FormDataType>({
    defaultValues: {
      title: '',
      status: undefined,
      direction: undefined,
      tier: undefined,
      id_1c: '',
      door_code: '',
      city_id: 0,
      address: '',
    },
  });

  const cityIdWatch = watch('city_id');

  const selectCity = cities?.find((city) => city.id === cityIdWatch);

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent style={{ width: '800px' }}>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            {actionDrawer === 'create' ? 'Создание торговой точки' : 'Изменение торговой точки'}
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <div>
            <div
              style={{
                marginBottom: '20px',
              }}
            >
              Адресная информация
            </div>
            <Controller
              name="address"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Адрес"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title && true}
                  {...field}
                />
              )}
            />
            <Controller
              name="door_code"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Код двери"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.door_code && true}
                  {...field}
                />
              )}
            />
            <Controller
              name="title"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Наименование"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.title && true}
                  {...field}
                />
              )}
            />
            <Controller
              control={control}
              name="city_id"
              render={({ field: { onChange } }) => (
                <FormControl
                  fullWidth
                  sx={{ marginBottom: '24px' }}
                >
                  <Autocomplete
                    options={cities || []}
                    value={selectCity || null}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(options) => options?.name_ru || options.name}
                    loading={citiesListSuccess}
                    loadingText="По вашему запросу ничего не найдено"
                    onChange={(event, value) => onChange(value?.id)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Город"
                      />
                    )}
                  />
                </FormControl>
              )}
            />
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <TextField
                  select
                  type="text"
                  label="Статус"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.status && true}
                  {...field}
                >
                  {statusList.map((tier) => (
                    <MenuItem value={tier.id}>{tier.value} </MenuItem>
                  ))}
                </TextField>
              )}
            />
            <Controller
              name="direction"
              control={control}
              render={({ field }) => (
                <TextField
                  select
                  type="text"
                  label="Канал"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.status && true}
                  {...field}
                >
                  {directionList.map((tier) => (
                    <MenuItem value={tier.id + 1}>{tier.value} </MenuItem>
                  ))}
                </TextField>
              )}
            />
            <Controller
              name="tier"
              control={control}
              render={({ field }) => (
                <TextField
                  select
                  type="text"
                  label="Уровень"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.status && true}
                  {...field}
                >
                  {tierList.map((tier) => (
                    <MenuItem value={tier.id + 1}>{tier.value} </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </div>
          <Box
            sx={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              variant="contained"
              onClick={handleSubmit(onSubmit)}
              sx={{
                textTransform: 'none',
              }}
            >
              Создать
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
